import { useState } from 'react';
import { faqs } from '@/mocks/faqs';
import SectionHeader from './SectionHeader';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return (
    <section className="section-pad bg-background-100">
      <div className="container-page">
        <SectionHeader
          eyebrow="常见问题"
          title="关于追更，你想知道的都在这里"
          desc="如果在阅读中还有疑问，欢迎随时通过联系我们页面找到我们。"
        />
        <div className="mx-auto max-w-3xl flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? 'border-primary-300 bg-background-50' : 'border-background-200/70 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950 md:text-base">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs ${open ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-900'}`}>
                      {index + 1}
                    </span>
                    {item.q}
                  </h3>
                  <i
                    className={`ri-add-line shrink-0 text-foreground-500 transition-transform ${open ? 'rotate-45' : ''}`}
                    aria-hidden="true"
                  />
                </button>
                {open && (
                  <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}